export default __webpack_public_path__ + "static/student-chem-draw-28c85f5cd7289fa9a4d1dfce85199e9e.png";